import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'

// Layouts
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { AuthLayout } from '@/components/layout/AuthLayout'

// Pages
import { Landing, Dashboard, RecordingDetail } from '@/pages'
import { Upload } from '@/pages/Upload'
import { Recordings } from '@/pages/Recordings'
import { VoiceLibrary } from '@/pages/VoiceLibrary'
import { Settings } from '@/pages/Settings'
import { Admin } from '@/pages/Admin'
import { Login } from '@/pages/auth/Login'
import { Register } from '@/pages/auth/Register'

// Componente per proteggere le rotte
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuthStore()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-4">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-slate-200 border-t-primary" />
          <p className="text-slate-500 font-medium animate-pulse">Caricamento Workspace...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      {/* Rotta Pubblica (Landing Page) */}
      <Route path="/" element={<Landing />} />

      {/* Rotte Autenticazione (Login/Register) */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Route>

      {/* Rotte Protette (Dashboard App) */}
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/recordings" element={<Recordings />} />
        <Route path="/recordings/:id" element={<RecordingDetail />} />
        <Route path="/voice-library" element={<VoiceLibrary />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin" element={<Admin />} />
      </Route>

      {/* Fallback per 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
